/* global React */
import { useTransition } from 'react'
import { Button, Grid } from '@mui/material'
import { withStyles } from '@mui/styles'
import { useMemoRef } from '@platform/react/hook'
import Preface from '@ui/Element/Text/Preface'
import Icon from 'ui/Element/Icon'

const styles = theme => ({
  root: {
    flexWrap: 'nowrap',
    justifyContent: 'left',
    alignItems: 'center',
  },
  iconContainer: {
    width: 'auto',
  },
  prefaceContainer: {
    paddingLeft: 24,
  },
  prefaceHeading: {
    color: theme.palette.secondary.main,
    textAlign: 'left',
  },
  ...theme.custom.iconPrefaceButton,
})

const IconPrefaceButton = ({ forwardedRef, events, icon, classes, ...props }) => {
  const [, startTransition] = useTransition()
  const handleClick = event => startTransition(() => events.onClick(event))

  return (
    <Grid
      container
      ref={forwardedRef}
      component={Button}
      onClick={handleClick}
      className={classes.root}
      elevation={0}
    >
      <Grid
        item
        container
        className={classes.iconContainer}
      >
        <Icon
          source={icon}
          color={'secondary'}
          size={24}
        />
      </Grid>
      <Grid
        item
        container
        className={classes.prefaceContainer}
        xs={10}
        sm={11}
      >
        <Preface
          heading={props.heading}
          text={props.text}
          variant={props.preface.variant}
          gutterBottom={props.preface.gutterBottom}
          classes={{ heading: classes.prefaceHeading }}
        />
      </Grid>
    </Grid>
  )
}

export default useMemoRef(withStyles(styles)(IconPrefaceButton), [])
